import React from 'react';
import AboutView from './aboutView';

const About = () => <AboutView />;

export default About;
